'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFileSearch, iconFileSearchTag } from '@ni/nimble-components/dist/esm/icons/file-search';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFileSearch };
export { iconFileSearchTag };
export const NimbleIconFileSearch = wrap(IconFileSearch);